module.exports = __webpack_public_path__ + "static/media/landing.2e2f908c.png";